import { Injectable } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import { EntityQuery, iBisEntityService } from '@dohu/ibis-entity';
import { iBisAuthService, iBisSecureEditService } from '@dohu/ibis-auth';
import { iBisLanguageService, iBisServerConfig } from '@dohu/ibis-common';
import { DataService } from '../../../../service/data.service';

@Injectable({
	providedIn: 'root'
})
export class EditSpecializationFormSettingsService extends iBisSecureEditService {
	public data: CustomStore;

	private spId: string;
	constructor(auth: iBisAuthService, entity: iBisEntityService, config: iBisServerConfig, lg: iBisLanguageService, private ds: DataService) {
		super(auth, entity, config, lg);
	}

	protected load(): void {
		this.data = this.getData();
	}

	public set specializationId(id: string) {
		this.spId = id;
		this.data = this.getData();
	}

	public get specializationId() {
		return this.spId;
	}

	createDefault(): any {
		return { };
	}
	getById(id: string): Promise<any> {
		return new Promise((resolve, reject) => {
			this.entity.getById('SpecializationFormSetting', id).then((obj) => {
				if (obj) {
					resolve(obj);
				} else {
					reject();
				}
			}, error => this.lg.showError(error));
		});
	}
	onRemove(id: string): Promise<void> {
		return this.entity.remove('SpecializationFormSetting', id);
	}
	onSaveEv(serverUrl?: string): Promise<any> {
		return this.entity.save('SpecializationFormSetting', this.model.id, this.model);
	}
	reset(): void {
		this.model = this.createDefault();
	}

	private getData(): CustomStore {
		const q = new EntityQuery('SpecializationFormSetting');
		if (this.spId) {
			q.eq('specializationId', this.spId);
		}
		return this.entity.store(q);
	}
}
export class SpecializationFormSetting {
	public id: string;
	public specializationId: string;
	public diagnosticEnabled: boolean;
	public patientHistoryEnabled: boolean;
	public patientFilesEnabled: boolean;
	public extraDescriptionEnabled: boolean;
	public observationEnabled: boolean;
	public notesEnabled: boolean;
	public treatmentEnabled: boolean;
	public uploadFilesEnabled: boolean;

	constructor(specId: string){
		this.id = null;
		this.specializationId = specId;
		this.diagnosticEnabled = false;
		this.patientHistoryEnabled = false;
		this.patientFilesEnabled = false;
		this.extraDescriptionEnabled = false;
		this.observationEnabled = false;
		this.notesEnabled = false;
		this.treatmentEnabled = false;
		this.uploadFilesEnabled = false;
	}
}
